import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Container from 'components/corpSite/components/shared/container'
import CircledIcon from 'components/corpSite/components/shared/circled-icon'
import { f_1_25, f_2 } from 'components/corpSite/components/theme/type-scale'
import { white, softForSite } from 'components/corpSite/components/theme/colors'
import { spacing_1, spacing_1_5, spacing_2 } from 'components/corpSite/components/theme/spacing'
import { xsMd } from 'components/corpSite/components/theme/utils/media-query'
import TrustIcon from 'components/corpSite/imgs/careguide-corp/icons/lock.svg'

const makeHeaderStyled = () =>
  styled.h2`
    font-size: ${f_2};
    font-weight: bold;
    color: ${white};
    display: block;
    margin-bottom: ${spacing_1};
    margin-top: 0;
  `
const HeaderStyled = makeHeaderStyled()

const makeDescriptionStyled = () =>
  styled.span`
    font-size: ${f_1_25};
    color: ${white};
    display: block;
  `
const DescriptionStyled = makeDescriptionStyled()

const makeTrustContainer = () =>
  styled.div`
    display: flex;
    text-align: left;
    align-items: center;
    ${() =>
      xsMd(
        css`
           {
            flex-direction: column;
            text-align: center;
          }
        `
      )};
  `

const TrustContainer = makeTrustContainer()

const Trust = (props) => (
  <TrustContainer maxWidth={'512px'}>
    <Container>
      <CircledIcon
        icon={TrustIcon}
        radius={128}
        background={softForSite('careguide.com')}
        marginRight={spacing_1_5}
        marginBottom={'0'}
        marginBottomMobile={spacing_2}
      />
    </Container>
    <Container>
      <HeaderStyled>Trust & Safety</HeaderStyled>
      <DescriptionStyled>
        Finding care online should feel safe. We use secure calling and scammer-fighting technology
        to ensure&nbsp; you are protected.
      </DescriptionStyled>
    </Container>
  </TrustContainer>
)

Trust.propTypes = {
  theme: PropTypes.object.isRequired,
}

export default Trust
